import {
    AfterViewInit,
    Component,
    ElementRef,
    HostListener,
    ViewChild,
} from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import { RiskReportingFeature } from "@features/RiskReportingFeature";
import { TerminologyService } from "@/_services/terminology/terminology.service";

interface NavItem {
    label: string;
    icon: string;
    routerLink: string[];
    feature?: string;
}

@UntilDestroy()
@Component({
    selector: "app-mobile-bottom-nav",
    templateUrl: "./mobile-bottom-nav.component.html",
    styleUrls: ["./mobile-bottom-nav.component.scss"],
})
export class MobileBottomNavComponent implements AfterViewInit {
    @ViewChild("navScroll")
    navScrollRef?: ElementRef<HTMLElement>;

    fadeLeft = false;
    fadeRight = false;

    readonly navItems: NavItem[];

    constructor(private terminology: TerminologyService) {
        this.navItems = [
            {
                label: this.terminology.resolve("nav.home"),
                icon: "home",
                routerLink: ["/home"],
            },
            {
                label: this.terminology.resolve("nav.forms"),
                icon: "forms",
                routerLink: ["/assessments"],
            },
            {
                label: this.terminology.resolve("nav.performance"),
                icon: "performance",
                routerLink: ["/performance"],
            },
            {
                label: this.terminology.resolve("nav.riskManagement.short"),
                icon: "srm",
                routerLink: ["/risk-management"],
                feature: RiskReportingFeature.key,
            },
            {
                label: this.terminology.resolve("nav.assurance"),
                icon: "assurance",
                routerLink: ["/assurance"],
            },
            {
                label: this.terminology.resolve("nav.promotion"),
                icon: "promotion",
                routerLink: ["/promotions"],
            },
            {
                label: this.terminology.resolve("nav.policy"),
                icon: "policy",
                routerLink: ["/policies"],
            },
            {
                label: this.terminology.resolve("nav.documents"),
                icon: "documents",
                routerLink: ["/manuals"],
            },
            {
                label: this.terminology.resolve("nav.account"),
                icon: "account",
                routerLink: ["/profile"],
            },
        ];
    }

    ngAfterViewInit() {
        this.updateFade();
    }

    @HostListener("window:resize")
    onWindowResize() {
        this.updateFade();
    }

    onScroll(event: Event) {
        const el = event.target as HTMLElement;
        this.applyFade(el);
    }

    private updateFade() {
        const el = this.navScrollRef?.nativeElement;
        if (el) {
            this.applyFade(el);
        }
    }

    private applyFade(el: HTMLElement) {
        const scrollLeft = el.scrollLeft;
        const maxScroll = el.scrollWidth - el.clientWidth;
        this.fadeLeft = scrollLeft > 5;
        this.fadeRight = maxScroll > 5 && scrollLeft < maxScroll - 5;
    }
}
